import type { CommunityMemberCharge } from "@/react/types/CommunityMemberCharge";
import { CommunityMemberPaymentMethodLine } from "@circle-react-shared/Paywalls/PaymentMethods/CommunityMemberPaymentMethodLine";
import { Line as PaymentMethodLine } from "@circle-react-shared/Paywalls/PaymentMethods/Line";

export interface PaymentPropertyProps {
  charge: CommunityMemberCharge;
}

export const PaymentProperty = ({ charge }: PaymentPropertyProps) => {
  if (!charge.payment_method_type) {
    return <div>-</div>;
  }
  if (!charge?.community_member_payment_method) {
    return <PaymentMethodLine variant="md" type={charge.payment_method_type} />;
  }

  return (
    <CommunityMemberPaymentMethodLine
      paymentMethod={charge.community_member_payment_method}
    />
  );
};
